import React from "react";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';
import { MdArrowForward } from "react-icons/md";
import { Accordion, AccordionItem } from '@szhsin/react-accordion';

function Faq() {

    let faqArraay = [
        {
            title: 'Чи підходить мені навчальна програма Women in Tech, якщо я не маю технічного бекграунду?',
            description: 'Так! Програма саме для тих, то хоче зробити перші кроки в цифровому світі — зрозуміло, доступно, з підтримкою. Запрошуємо до участі жінок, які хочуть опанувати цифрові навички, дізнатися про сучасні професії, розпочати кар’єру в онлайн-сфері або запустити власну справу. Неважливо, маєш ти досвід, технічну освіту чи просто ідею — головне бажання діяти.'
        },
        {
            title: 'Я живу за кордоном. Чи можу я брати участь?',
            description: 'Так. Програма проходить онлайн, тому ти можеш долучитися з будь-якої точки світу.'
        },
        {
            title: 'Чи буде запис освітніх вебінарів та інших онлайн-активностей?',
            description: 'Так, проєкт передбачає запис онлайн-трансляцій освітніх вебінарів, але радимо долучатися наживо, аби мати змогу поставити запитання спікерам та отримати максимум користі від контенту. Крім освітніх вебінарів із трансляцією на YouTube (загальною тривалістю 22 години), передбачені групові інтерактивні сесії у Zoom (зумінари), які ми не плануємо транслювати наживо або записувати.'
        },
        {
            title: 'Чи потрібно реєструватися на окремий тематичний модуль чи вебінар?',
            description: 'Реєстрація одна для всієї програми. Ми радимо пройти повністю весь курс. Ви отримаєте повідомлення на email з анонсами окремих подій.'
        },
        {
            title: 'Куди можна звернутися за допомогою у випадку проблеми з доступом до програми/вебінару?',
            description: 'З будь-якими питаннями, що стосуються проєкту, звертайтеся на пошту info@womenintech.com.ua. Ми допоможемо вирішити.'
        }
    ]

    return (
        <section className="relative mb-20" id="ebaut">
            <div className="container w-[90%] max-w-screen-lg lg:w-3/4 mx-auto rounded-2xl">
                <div className="mb-10">
                    {/*<ScrollAnimation animateIn="animate__fadeInUp"><h6 className="bg-[#F3FF80] w-max px-3 py-1 mb-4 rounded-2xl">Про івент</h6></ScrollAnimation>*/}
                    <ScrollAnimation animateIn="animate__fadeInUp"><h2
                        className="sm:text-4xl text-2xl mb-4 uppercase text-center">FAQ</h2>
                    </ScrollAnimation>
                </div>
                <Accordion allowMultiple transition transitionTimeout={250}>
                    {
                        faqArraay?.map((item, index) => (
                            <AccordionItem className="py-3" header={<div
                                className="text-start flex flex-wrap items-center"><MdArrowForward
                                className="text-3xl text-[#AF00A9] w-[30px] mr-[15px]"/>
                                <div className="w-[calc(100%-45px)]">{item.title}</div>
                            </div>}>
                                <div key={index}>
                                    <p className="mt-3">{item.description}</p>
                                </div>
                            </AccordionItem>
                        ))
                    }
                </Accordion>

            </div>
        </section>
    )
}

export default Faq